// extracted by mini-css-extract-plugin
export var menu = "style-module--menu--AEpW7";